import { createSlice } from "@reduxjs/toolkit";

const mapSlice = createSlice({
  name: "map",
  initialState: {
    coordinates: { lat: "", lng: "" },
    markerPosition: null,
    date: {
      datePickerTimeFrom: "",
      datePickerTimeTo: "",
      dataPickerTime: "",
    },

    areas: [
      /**
       * sample Model
       * {
       * polId,
       * coordinates,
       * imgurl,
       * img64,
       * data: { stats, timestamps
       * }
       * }
       */
    ],
    currentWeather: {},
    weatherStats: {},
    uploadedFileContent: "",
    maskingFileContent: "",
    uploaderFlag: false,
    downloadLinks: [],
    showOverlay: true,
  },
  reducers: {
    setDownloadLink: (state, action) => {
      state.downloadLinks.push(action.payload);
    },
    setMarkerPosition: (state, action) => {
      state.markerPosition = action.paylaod;
    },
    setShowOverlay: (state, action) => {  
      state.showOverlay = action.payload;
    },
    // poly actions
    addArea: (state, action) => {
      console.log("payload", action.payload);
      const existingArea = state.areas.find(
        (a) =>
          // Check if coordinates are equal
          JSON.stringify(a.coordinates) ===
          JSON.stringify(action.payload.coordinates)
      );
      if (existingArea) {
        return state; // If area already exists, return current state
      } else {
        return {
          ...state,
          areas: [...state.areas, action.payload], // Add new area to areas array
        };
      }
    },
    setAreaStats: (state, action) => {
      const { polyId, data } = action.payload;
      state.areas = state.areas.map((area) => {
        if (area.polyId === polyId) {
          console.log("data in redux", data);
          area.data = data;
        }
        return area;
      });
    },
    setAreaImage: (state, action) => {
      const { polyId, imgurl, img64, bbox, imagename } = action.payload;
      state.areas = state.areas.map((area) => {
        if (area.polyId === polyId) {
          area.imgurl = imgurl;
          area.img64 = img64;
          area.bbox = bbox;
          area.imagename = imagename;
        }
        return area;
      });
    },
    deleteArea: (state, action) => {
      const deletedIds = action.payload;
      state.areas = state.areas.filter((area) => {
        return !deletedIds.includes(area.polyId.toString());
      });
    },
    clearAreas: (state, action) => {
      state.areas = [];
    },
    //date actions
    setDatePickerFrom: (state, action) => {
      state.date.datePickerTimeFrom = action.payload;
    },
    setDatePickerTo: (state, action) => {
      state.date.datePickerTimeTo = action.payload;
    },
    clearDates: (state) => {
      state.date.datePickerTimeFrom = "";
      state.date.datePickerTimeTo = "";
    },
    setCurrentWeather: (state, action) => {
      state.currentWeather = action.payload;
    },
    setWeatherStats: (state, action) => {
      state.weatherStats = action.payload;
    },
    setFileContent: (state, action) => {
      state.uploadedFileContent = action.payload;
    },
    setMaskingFileContent: (state, action) => {
      console.log("action payload", action.payload);
      state.maskingFileContent = action.payload;
    },
    clearFileContent: (state) => {
      state.uploadedFileContent = "";
    },
    setCoordinates: (state, action) => {
      console.log("ACTION:", action);
      state.coordinates = { ...state.coordinates, ...action.payload };
      console.log("COORDS:", state.coordinates);
    },
    clearAllMapState: (state) => {
      state.areas = [];
      state.currentWeather = {};
      state.weatherStats = {};
      // state.uploadedFileContent = "";
    },
    setUploaderFlag: (state, action) => {
      state.uploaderFlag = action.payload;
    },
  },
});

export const {
  addArea,
  setAreaStats,
  setAreaImage,
  deleteArea,
  clearAreas,
  setDatePickerFrom,
  setDatePickerTo,
  clearDates,
  setCurrentWeather,
  setWeatherStats,
  setFileContent,
  clearFileContent,
  clearAllMapState,
  setUploaderFlag,
  unSetUploaderFlag,
  setDownloadLink,
  setMarkerPosition,
  setCoordinates,
  setMaskingFileContent,
  setShowOverlay,
} = mapSlice.actions;

export default mapSlice.reducer;
